import { Visual } from './Visual';
import { VisualFieldRole } from './VisualFieldRole';
import { VisualFieldRoleType } from './VisualFieldRoleType';

export class VisualFieldRoleTypeMap
  implements Iterable<VisualFieldRoleType> {
  public readonly types: ReadonlyArray<VisualFieldRoleType>;

  constructor(types: ReadonlyArray<VisualFieldRoleType>) {
    let sortedTypes = [...types];
    sortedTypes.sort((a, b) => b.usagePriority - a.usagePriority);
    this.types = sortedTypes;
  }

  get size() {
    return this.types.length;
  }

  find(kindOrName: VisualFieldRoleType.Kind | string): VisualFieldRoleType {
    if (typeof kindOrName === 'string') {
      let name = VisualFieldRole.Usage.tryParse(kindOrName) ?? kindOrName.toLowerCase();
      return this.types.find(r => r.name.toLowerCase() == name);
    }
    else {
      let kind = kindOrName;
      return this.types.find(r => r.kind == kind);
    }
  }

  *[Symbol.iterator](): Iterator<VisualFieldRoleType> {
    for (let r of this.types)
      yield r;
  }
}

export namespace VisualFieldRoleTypeMap {
  export type Input = Readonly<Record<string, VisualFieldRoleType>>;

  export function create<TInput extends Input = Input>(roles: TInput): VisualFieldRoleTypeMap & TInput {
    let roleMap = new VisualFieldRoleTypeMap(Object.values(roles));

    for (let [k, v] of Object.entries(roles))
      (roleMap as any)[k] = v;

    return <VisualFieldRoleTypeMap & TInput>roleMap;
  }
}
